import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

export interface WrapperStateProps
{
    element:React.FC<any>;
}

export interface WrapperDispatchProps
{
    onLoad?:()=> void;
    onChangeParams?:(params:any)=> void;
    onChangeSearchParams?:(params:URLSearchParams | undefined)=> void;
}

type WrapperProps = WrapperStateProps & WrapperDispatchProps

const Wrapper: React.FC<WrapperProps> = (props) =>
{
    const parms:any = useParams();
    const searchParms:any = useSearchParams();
    const [lastParms, setLastParms] = useState<string | undefined>(undefined);
    const [lastSearchParms, setLastSeaarchParms] = useState<URLSearchParams | undefined>(undefined);

    useEffect(()=> 
    {
        var paramsStr = JSON.stringify(parms);
        if (paramsStr === lastParms) return;
        
        setLastParms(paramsStr);
    },[parms]);

    useEffect(()=> 
    {
        var data:URLSearchParams | undefined;

        if (searchParms.length> 0) data = searchParms[0];
        if (data === lastSearchParms) return;
        
        setLastSeaarchParms(data);
    },[searchParms]);

    useEffect(()=> 
    {  
        if (!lastParms) return;
        props.onChangeParams && props.onChangeParams(JSON.parse(lastParms));

    },[lastParms])

    useEffect(()=> 
    {  
        if (!lastSearchParms) return;
        props.onChangeSearchParams && props.onChangeSearchParams(lastSearchParms);

    },[lastSearchParms])

    return <props.element {...props}/>
};

export { Wrapper};
